module.exports = __webpack_public_path__ + "img/hc_pro_six_3.8ea4aa9b.jpg";